// TODO create common interface with epg-cache
import { FormatKalturaProductPricePpv } from '../interfaces';

import { tvpilGetLocalCache } from './caching-service';
import { PurchaseStates } from './subscriptions.helper';

const PURCHASE_TTL = 2 * 60 * 1000;

export let priceCache: { [key: string]: FormatKalturaProductPricePpv[] } = {};

interface ProductPricesCache {
  cachedFilePrices: FormatKalturaProductPricePpv[];
  noCachedFilePriceIds: number[];
  cachedFilePriceIds: number[];
}

export interface PurchaseCache {
  subscriptionId?: string;
  purchaseState: PurchaseStates;
  mediaFileId?: number;
  endDate?: number;
}

export const setPurchaseCache = (purchaseObject: PurchaseCache): void => {
  if (purchaseObject.purchaseState === PurchaseStates.error) {
    // TODO state: PurchaseStates.noPaymentGateways , state: PurchaseStates.redirect
    return;
  }
  const cache = tvpilGetLocalCache();
  cache.setItem(
    `purchase_${purchaseObject.mediaFileId || purchaseObject.subscriptionId}`,
    purchaseObject,
    PURCHASE_TTL,
  );
};

export const getPurchaseCache = async (
  mediaFileId?: number,
  purchaseId?: string,
): Promise<PurchaseCache | undefined> => {
  const cache = tvpilGetLocalCache();
  return (await cache.getItem(`purchase_${mediaFileId || purchaseId}`)) as PurchaseCache;
};

export const getProductPricesCache = ({ fileIds = [] as number[] }): ProductPricesCache => {
  const completeList = fileIds;

  const noCachedFilePriceIds = completeList.filter((fileId) => {
    return priceCache[`file_price_${fileId}`] === undefined && fileId;
  });

  const cachedFilePriceIds = completeList.filter((fileId) => {
    return priceCache[`file_price_${fileId}`] !== undefined && fileId;
  });

  const cachedFilePrices: FormatKalturaProductPricePpv[] = [];
  cachedFilePriceIds.forEach((fileId) => {
    cachedFilePrices.push(...priceCache[`file_price_${fileId}`]);
  });

  return { noCachedFilePriceIds, cachedFilePriceIds, cachedFilePrices };
};

export const setProductPricesCache = (prices: FormatKalturaProductPricePpv[]) => {
  prices.map((price: FormatKalturaProductPricePpv) => {
    if (Array.isArray(priceCache[`file_price_${price.fileId}`])) {
      priceCache[`file_price_${price.fileId}`].push(price);
    } else {
      priceCache[`file_price_${price.fileId}`] = [price];
    }
  });
};

export const clearFilePrices = () => {
  priceCache = {};
};
